"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class InsertScriptButton extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInputDialog: false,
      script: ''
    };
  }
  getTagName(script) {
    if (script.startsWith('<iframe')) {
      return 'iframe';
    } else if (script.startsWith('<script')) {
      return 'script';
    }
    throw new Error('Sorry, script name not permitted');
  }
  handleInsertScript() {
    const handleInsertScript = this.props.handleInsertScript;
    const script = this.state.script;
    handleInsertScript(this.getTagName(script), script);
    this.setState({
      script: '',
      showInputDialog: false
    });
  }
  render() {
    const _this$props = this.props,
      buttonClassName = _this$props.buttonClassName,
      popoverClassName = _this$props.popoverClassName;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      className: buttonClassName,
      onClick: e => this.setState({
        showInputDialog: !this.state.showInputDialog
      })
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-code"
    })), !this.state.showInputDialog ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: popoverClassName
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      value: this.state.script,
      onChange: e => this.setState({
        script: e.target.value
      })
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-outline white mx1",
      onClick: this.handleInsertScript.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-check"
    }))));
  }
}
var _default = exports.default = InsertScriptButton;